/**
 * Katalog over Python-parsers til Kostpris Agent.
 *
 * Én entry pr. leverandør vi kan læse en prisliste fra. Parseren selv bor i
 * agents/shared/parsers/<slug>/parser.py (implementeres i næste fase; endnu
 * ikke bygget). Her ligger KUN et katalog UI'et kan referere til, så
 * Leverandører-siden kan vise en dropdown.
 *
 * Nye parsere:
 *   1. Opret ny mappe agents/shared/parsers/<slug>/ med parser.py + config.json
 *   2. Tilføj entry her (slug matcher mappe-navn)
 *   3. Cockpit-deploy (så UI'et viser den nye option)
 *
 * Deles mellem web (dropdown) og server (validering).
 */

export interface ParserOption {
  /** Fx "cerdomus" — matcher mappe-navn under agents/shared/parsers/. */
  slug: string;
  /** Menneskeligt navn til UI-dropdown. */
  label: string;
}

export const PARSER_OPTIONS: readonly ParserOption[] = [
  { slug: 'cerdomus', label: 'Cerdomus' },
  { slug: 'colour_ceramica', label: 'Colour Ceramica' },
  { slug: 'ariana', label: 'Ariana' },
  { slug: 'alterat', label: 'Alterat' },
  { slug: 'kuma', label: 'Kuma' },
  { slug: 'cristina', label: 'Cristina' },
  { slug: 'dansani', label: 'Dansani' },
  { slug: 'geromin', label: 'Geromin' },
] as const;

export const PARSER_SLUGS: readonly string[] = PARSER_OPTIONS.map((p) => p.slug);
